module.exports = __webpack_public_path__ + "static/media/cheers.a680ea34.svg";